// Ponte com o host. O gold miner é deploy stand-alone (URL própria), mas em
// runtime roda EMBEDDED num iframe dentro do `profile-games`. Dentro do iframe
// `window.ReactNativeWebView` NÃO existe, então a mensagem vai pro parent
// (profile-games), que mostra o modal "Fechar o jogo?" / repassa pro RN. Se um
// dia rodar direto numa WebView do RN (sem iframe), cai no `ReactNativeWebView`.

type ReactNativeWindow = Window & {
  ReactNativeWebView?: { postMessage: (message: string) => void }
}

function sendToHost(message: string): boolean {
  if (window.parent && window.parent !== window) {
    window.parent.postMessage(message, '*')
    return true
  }

  const rn = (window as ReactNativeWindow).ReactNativeWebView
  if (rn) {
    rn.postMessage(message)
    return true
  }

  return false
}

// Avisa o host pra abrir o modal de confirmação de fechar o jogo.
export function notifyCloseGame(): void {
  if (!sendToHost('close-game')) {
    window.history.back()
  }
}

// Avisa o host pra abrir a tela de recarga de moedas.
export function notifyOpenRecharge(): void {
  sendToHost('open-modal-recharge')
}
